module.exports = __webpack_public_path__ + "assets/img/no-profile-pic.48b14e67.jpg";